<button mat-raised-button color="primary" class="m-3" *ngIf="!fixture.round_set.length"
  (click)="createFixture()">Generar Fixture</button>
<div class="fixture__container" *ngIf="fixture.round_set.length">
  <div *ngFor="let round of fixture.round_set; let i = index">
    <div class="round_title">
      <span>{{ i + 1 }}° Fecha</span>
      <div class="separator"></div>
    </div>
    <div class="matches_container">
      <div class="match" *ngFor="let match of round.match_set; let idx = index">
        <div class="match_info" *ngIf="fields.length">
          <span class="field text-primary">
            {{ getMatchField(match.field) }}
          </span>
          <span class="time">
            {{ getMatchTime(match.datetime) }}
          </span>
          <div class="options" *ngIf="match.team_a && match.team_b">
            <button mat-button mat-icon-button [matMenuTriggerFor]="healthTableOptions">
              <i class="material-icons">more_vert</i>
            </button>
            <mat-menu #healthTableOptions="matMenu" xPosition="before">
              <button mat-menu-item (click)="openMatchResultModal(match, round)" class="uppercase">Cargar
                Resultado</button>
            </mat-menu>
          </div>
        </div>
        <div class="teams" *ngIf="tournamentTeams.length">
          <div class="team_a">
            <img class="mr-1" src="{{ getTeamProperty(match.team_a, 'photo') }}" alt="" />
            <span class="name"
              matTooltip="{{ getTeamProperty(match.team_a, 'name') }}">{{ getTeamProperty(match.team_a, 'name') }}</span>
            <span style="margin-left: auto;" class="{{
                match.score_team_a > match.score_team_b
                  ? 'text-primary score'
                  : ''
              }}">{{ match.score_team_a === null ? '' : match.score_team_a }}</span>
          </div>
          <span class="mx-2">-</span>
          <div class="team_b">
            <span style="margin-right: auto;" class="{{
                match.score_team_a < match.score_team_b
                  ? 'text-primary score'
                  : ''
              }}">{{ match.score_team_b === null ? '' : match.score_team_b }}</span>
            <span class="name"
              matTooltip="{{ getTeamProperty(match.team_b, 'name') }}">{{ getTeamProperty(match.team_b, 'name') }}</span>
            <img class="ml-1" src="{{ getTeamProperty(match.team_b, 'photo') }}" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>